import { describeEasmScanReason } from '../hooks/easm';

// ROAR-5051/ROAR-5053 (AC1, AC5) — shared by the asset-row Start▾ dropdown
// (AllAssetsDatav2.js) and the bulk-selection checkbox/toolbar (AllTableData.js). Lives here
// rather than being defined in and imported from AllAssetsDatav2.js because AllAssetsDatav2.js
// itself imports AllTableData — importing the other way would be a circular import.
//
// Reads easm_eligible/parent_id/easm_scan_status straight off the listing API row
// (GET /AssetManagement/listAssets), no client-side eligible-type list.
export const getEasmMenuItemState = (asset) => {
  if (!asset?.easm_eligible || asset?.parent_id) {
    return { visible: false, disabled: false, tooltip: null };
  }
  const disabled = asset?.easm_scan_status === 'inprogress';
  return { visible: true, disabled, tooltip: disabled ? describeEasmScanReason('already_running') : null };
};
